import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'order',
    serviceName: 'auth',
    query: gql`
      query getOrder($ids: [String], $for_admin: Int) {
        order(ids: $ids, for_admin: $for_admin) {
          data {
            co_products_cost
            me_products_cost
            products_discount
            order_discount
            discount_title
            total_discount
            shipping_cost
            wallet_settled_amount
            paid_cost
            total_cost
            discount {
              id
              value
              discount_type {
                title
              }
            }
            coupons {
              amount
              coupon {
                title
              }
            }
            transactions {
              id
              type
              price
              status
              ref_code
              created_at
              description
              detail {
                pan
                ref_id
                terminal {
                  title
                }
              }
            }
          }
        }
      }
    `,
  },
};

export default schema;
